import { useState } from "react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { api, errorMessage } from "../lib/api";

export const ImportCsvSheet = ({ open, onOpenChange, csrfToken, onImported }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleOpenChange = (next) => {
    if (!next) { setFile(null); setResult(null); setError(""); }
    onOpenChange(next);
  };
  const upload = async () => {
    if (!file) return;
    setBusy(true); setError(""); setResult(null);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/venues/import", form, { headers: { "X-CSRF-Token": csrfToken } });
      setResult(data); setFile(null); onImported();
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent side="bottom" className="hud-sheet import-sheet" closeTestId="import-close-button" data-testid="import-sheet">
        <div className="sheet-grab" aria-hidden="true" />
        <SheetHeader><SheetTitle className="sheet-title" data-testid="import-title">IMPORTA CSV</SheetTitle></SheetHeader>
        <label className="form-label" htmlFor="venue-csv">FILE CSV</label>
        <input id="venue-csv" className="csv-input" type="file" accept=".csv,text/csv" data-testid="import-file-input" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        {file && <p className="selected-file" data-testid="import-selected-file">{file.name}</p>}
        {error && <p className="form-error" role="alert" data-testid="import-error">{error}</p>}
        {result && <div className="import-results" role="status" data-testid="import-results">
          <div data-testid="import-count">Importati <strong>{result.importati}</strong></div>
          <div data-testid="duplicate-count">Doppioni scartati <strong>{result.duplicati}</strong></div>
          <div data-testid="invalid-count">Righe non valide <strong>{result.righe_non_valide}</strong></div>
        </div>}
        <Button type="button" className="hud-button" onClick={upload} disabled={!file || busy} data-testid="import-submit-button">{busy ? "Importazione…" : "Importa locali"}</Button>
      </SheetContent>
    </Sheet>
  );
};